import React from 'react'
import { Grid, List,ListItem, ListItemText, Typography } from '@material-ui/core';
import LinkButton from './LinkButton';
class Footer extends React.Component{
    constructor(props){
        super(props);

    }
    render(){
        let year=new Date().getFullYear();
        
        return  <Grid container  justify='space-around' 
            style={{
                background: '#0080ff',
                color: 'white'
            }}
        >
            <Grid item xs={12} sm={4} md={4} lg={4} >
                <div style={{
                    display: 'flex',
                    justifyContent: 'center'
                }}>

                <List >
                    <ListItem>
                        <ListItemText>
                           <Typography variant='h6' >
                                 Links
                            </Typography>
                        </ListItemText>
                    </ListItem>

                    <ListItem>
                        <ListItemText>
                            <LinkButton
                            url={"/"}
                            text="Home"
                            />
                        </ListItemText>
                    </ListItem>

                    <ListItem>
                        <ListItemText>
                            <LinkButton
                            url={"/get-started"}
                            text="Get started"
                            />
                        </ListItemText>
                    </ListItem>

                    <ListItem>
                        <ListItemText>
                        <LinkButton
                            url={"/api"}
                            text="Api Documentation"
                            />
                        </ListItemText>
                    </ListItem>

                    <ListItem>
                        <ListItemText>
                        <LinkButton
                            url={"/examples"}
                            text="Examples"
                            />
                        </ListItemText>
                    </ListItem>
                </List>
                </div>
            </Grid>
            <Grid item xs={12} sm={4} md={4} lg={4} >
            <div style={{
                    display: 'flex',
                    justifyContent: 'center'
                }}>

            {/* <List >
                    <ListItem>
                        <ListItemText>
                           <Typography variant='h6'>
                                 Community
                            </Typography>
                        </ListItemText>
                    </ListItem>

                    <ListItem>
                        <ListItemText>
                           <Typography variant='subtitle2'>
                               Stack overflow
                            </Typography>
                        </ListItemText>
                    </ListItem>

                    <ListItem>
                        <ListItemText>
                           <Typography variant='subtitle2'>
                                Feedback
                            </Typography>
                        </ListItemText>
                    </ListItem>
                    <ListItem>
                    <ListItemText>
                           <Typography variant='subtitle2'>
                            Github
                            </Typography>
                        </ListItemText>
                    </ListItem>
                </List> */}
                </div>
            </Grid>
            <Grid  item xs={12} sm={4} md={4} lg={4} >
                </Grid>
                <Grid item xs={12} sm={12} lg={12} md={12}>
                    <div style={{padding: '20px'}} >
                        <div style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    padding: '20px'
                                }}>
                                    <div style={{background: 'white',border: '10px solid white',borderRadius: '50%'}}>
                                        <img src='/logo.png' style={{
                                                width: '50px',
                                                height: '50px'
                                        }}/>
                                    </div>
                                    <div style={{padding:'5px'}}>
                                        <Typography variant='h4'>
                                            Actumjs
                                        </Typography>
                                    </div>
                                </div>
                                    <Typography align='center'>Copyright &copy; {year-1}-{year-2000}, Actumjs.</Typography>
                    </div>
                </Grid>
        </Grid>
    }
}
export default Footer